import React from 'react';

const PreForward = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='14'
      viewBox='0 0 18 14'
      fill='none'
      {...props}
    >
      <path
        d='M8.45312 13.7725C8.75521 13.7725 9.00521 13.6852 9.20312 13.5106C9.40104 13.336 9.5 13.1178 9.5 12.8559V10.3683H9.69531C10.6536 10.3683 11.4948 10.4579 12.2188 10.637C12.9427 10.8162 13.5755 11.1079 14.1172 11.5122C14.6641 11.9165 15.1432 12.4586 15.5547 13.1385C15.7109 13.3866 15.8802 13.5497 16.0625 13.6277C16.25 13.7058 16.4453 13.7449 16.6484 13.7449C16.9193 13.7449 17.1458 13.6346 17.3281 13.4141C17.5156 13.1982 17.6094 12.8766 17.6094 12.4494C17.6094 11.1998 17.4505 10.0788 17.1328 9.08654C16.8151 8.08963 16.3307 7.23973 15.6797 6.53684C15.0339 5.83395 14.2135 5.29875 13.2188 4.93122C12.224 4.55911 11.0495 4.37305 9.69531 4.37305H9.5V1.90605C9.5 1.64418 9.40104 1.42137 9.20312 1.23761C9.00521 1.04926 8.75 0.955078 8.4375 0.955078C8.22917 0.955078 8.04167 0.996425 7.875 1.07912C7.70833 1.15722 7.51302 1.29044 7.28906 1.4788L1.10156 6.56441C0.945312 6.68845 0.835938 6.82167 0.773438 6.96409C0.710938 7.10191 0.679688 7.23514 0.679688 7.36377C0.679688 7.48781 0.710938 7.62104 0.773438 7.76345C0.835938 7.90587 0.945312 8.03909 1.10156 8.16313L7.28906 13.2901C7.49219 13.4601 7.68229 13.5818 7.85938 13.6553C8.04167 13.7334 8.23958 13.7725 8.45312 13.7725Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default PreForward;
